import { render, staticRenderFns } from "./BTableFooter.vue?vue&type=template&id=0d808538&scoped=true&"
import script from "./BTableFooter.vue?vue&type=script&lang=js&"
export * from "./BTableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d808538",
  null
  
)

export default component.exports